import { getFormattedTrackingString } from 'root/utils/tracking/BTFNavTracking/getFormattedTrackingString';

/**
 * Locate the clicked item based on the nav 3 levels (parent, child, grand child)
 * and concatenate the different levels into a single string.
 * example: parent, parent>child, parent>child>grand_child
 * @param clickedLink
 * @returns {string}
 */
const getClickedElAncestorsText = clickedLink => {
    let { parent, child, grandChild } = {
        parent: clickedLink.closest('[data-navigation-level=parent]'),
        child: clickedLink.closest('[data-navigation-level=child]'),
        grandChild: clickedLink.closest('[data-navigation-level=grandchild]'),
    };

    const stringsArray = [];
    const clickedLinkParentEl = clickedLink.parentElement; // We are comparing against the parent of the clicked item because we are checking the parent of each of the different nav levels.
    const isParent = parent && clickedLinkParentEl === parent;
    const isChild = child && clickedLinkParentEl === child;
    const isGrandChild = grandChild && clickedLinkParentEl === grandChild;
    const breadcrumbParent = parent.previousElementSibling;

    isParentBreadCrumb(breadcrumbParent) && (parent = breadcrumbParent);
    isParent && checkAndPushToArray(stringsArray, [parent]);
    isChild && checkAndPushToArray(stringsArray, [parent, child]);
    isGrandChild && checkAndPushToArray(stringsArray, [parent, child, grandChild]);
    // Removes duplicates from array and separate family with ">"
    return stringsArray.join('>');
};

/**
 * Check if an el is valid and push to the array
 * @param arr
 * @param args
 */
const checkAndPushToArray = (arr, [...args]) => {
    args.forEach(
        el => el && el.innerText && arr.push(getFormattedTrackingString(el.innerText))
    );
};

/**
 *
 * @param breadcrumbParent
 * @returns {boolean}
 */
const isParentBreadCrumb = breadcrumbParent => {
    if (breadcrumbParent) {
        // Check if it is a breadcrumb and send the breadcrumb string along with the child el
        return (
            breadcrumbParent.dataset.navigationLevel === 'parent' &&
            breadcrumbParent.classList.contains(
                'navigation-btf-mobile__item--breadcrumb-first'
            )
        );
    }
    return false;
};

export default getClickedElAncestorsText;
